//demonstrates instanced drawing

import ShaderService from "../../../lib/services/shader/shader_service";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";
import SceneObject from "../../../lib/services/scene/sceneobject";
import Papercloud from "./papercloud";
import DioramaRenderPipelineInstanced from "../../../lib/services/render/pipelines/diorama_renderpipeline_instanced";
import Transform from "../../../lib/services/render/transform";
import PlaceTransform from "../../../lib/services/scene/place_transform";
const MOVE_Z = -5.0;//-3.1;

export default class Sky extends SceneObject 
{
    cloud_panels: Papercloud[] = [];
    sky_inst:DioramaRenderPipelineInstanced;
    cloud_inst:DioramaRenderPipelineInstanced;
    place_t:PlaceTransform;


  constructor(key: string) 
  {
     super(key);

     const si= 0;
     this.place_t= new PlaceTransform("nf"+si,this.transform);
     this.sky_inst = this.make_sky_panels();
     this.cloud_inst = this.make_cloud_panels();

    
     this.place_t.set_transform(this.cloud_inst.transforms[si]);   

 }

  async build(device: GPUDevice, format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {
        this.sky_inst.build(device,format,shader_service,resource_service);
        this.cloud_inst.build(device,format,shader_service,resource_service);
        
        super.build(device,format,shader_service,resource_service);
  }

  make_transform(x:number,y:number,z:number,sx:number,sy:number,sz:number):Transform
  {
      const t = new Transform();
      t.set_position(x,y,z);
      t.set_rotation(0, 0, 0);
      t.set_scale(sx,sy,sz);
      t.update_matrix();
      return t;
  }
  
  make_sky_panels():DioramaRenderPipelineInstanced
  {
     //1536x1024
     const width = 3;
     const height = 2;
     const y = 0.5;
     const s = 1.75;
     const z = -7.5+MOVE_Z
     var transforms:Transform[] =[];
     transforms.push(this.make_transform(-19.754775047302246,y,z,-s,s,s));
     transforms.push(this.make_transform(-14.754775047302246,y,z,s,s,s));
     transforms.push(this.make_transform(-9.971558570861816,y,z,-s,s,s));
     transforms.push(this.make_transform(-5.056499004364014,y,z,s,s,s));
     transforms.push(this.make_transform(0,y,z,-s,s,s));
     transforms.push(this.make_transform(5.169861316680908,y,z,s,s,s));
     transforms.push(this.make_transform(10.4,y,z,-s,s,s));
     transforms.push(this.make_transform(15.643829345703125,y,z,s,s,s));

      const drp= new DioramaRenderPipelineInstanced("sky","unlit_texture_alpha_instanced","sky_only",width,height,transforms);
      return drp;
  }


  make_cloud_panels():DioramaRenderPipelineInstanced
  {
     const width = 4;
     const height = 3;
     var transforms:Transform[] =[];
     const z =-9.0;
     
     transforms.push(this.make_transform(2.028409004211426,0.3134600818157196,z,0.7580538392066956,0.7580538392066956,0.7580538392066956));
     transforms.push(this.make_transform(0.9546302556991577,1.2804893255233765,z+0.3,0.5679671764373779,0.5679671764373779,0.5679671764373779));
     transforms.push(this.make_transform(-0.26428112387657166,0.8986893892288208,z+0.5,0.34833210706710815,0.34833210706710815,0.34833210706710815));
     transforms.push(this.make_transform( -2.757800817489624,0.7085193395614624,z,0.57988572120666,0.57988572120666,0.57988572120666));
    
      const drp= new DioramaRenderPipelineInstanced("clouds","unlit_texture_alpha_instanced","cloud0",width,height,transforms);
      return drp;
   
  }

  tick(delta_time: number): void 
  {
     super.tick(delta_time);
    // this.place_t.tick(delta_time); //comment in to move an object arround and get its location in console
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
     this.sky_inst.prepare(device,camera);
     this.cloud_inst.prepare(device,camera);
     super.prepare(device,camera);
  }

  draw(pass: GPURenderPassEncoder): void 
  {
     this.sky_inst.draw(pass);
     this.cloud_inst.draw(pass);
     super.draw(pass);
  }
}